import {$_window}      from "../../../../base/js/helpers/dom";
import {IS_PRODUCTION} from "../../../../base/js/helpers/system";
import filter          from './filter';

const COMPONENT = 'content_browser';

export default () => {
  $(`.${COMPONENT}`).each((index, component) => {
    const $component = $(component);
    /** @type {ContentBrowserModel} */
    const model = {
      context:        $component,
      data:           $component.data('component'),
      filter:         parseHash(),
      onFilterUpdate: applyFilter,
    };

    const $window = $_window();

    filter(model);

    init();

    function applyFilter() {
      toHash();

      $component.find('.content_browser__grid .row')
        .html(`<div class="content_browser__has_more loading" data-component="{&quot;next&quot;:0}"><i class="fa fa-spin fa-spinner"></i></div>`);

      loadMore();
    }

    function init() {
      loadMore();

      $window.on('scroll', onScroll);

      const $buttonLoadMore = $component.find('.load-more');

      $buttonLoadMore.on('click', function () {
        loadMore();
      });
    }

    function loadMore() {
      const $hasMore = $component.find('.content_browser__has_more');
      const hasMoreData = $hasMore.data('component');

      const modelData = model.data;
      let amount = modelData.amount;
      const width = $window.width();

      if (width < 414)
      {
        amount = 4;
      }
      else if (width < 768)
      {
        amount = 6;
      }

      const category = model.filter.category;

      const filter = {
        Storages: (category === 'all')
                    ? [modelData.campaigns,
                       modelData.news_events,
                       modelData.seminar_webinar]
                    : [modelData[category]],
        From:     hasMoreData.next,
        Amount:   amount,
      };

      if (filter.Storages.indexOf(modelData.campaigns) > -1)
      {
        filter.ProductArea = extractTags(model.filter.product_area);
      }

      if (filter.Storages.indexOf(modelData.news_events) > -1)
      {
        filter.EventType = extractTags(model.filter.event_type);
      }

      if (filter.Storages.indexOf(modelData.seminar_webinar) > -1)
      {
        filter.SeminarType = extractTags(model.filter.seminar_type);
      }

      filter.Brand = extractTags(model.filter.brand);

      $hasMore.addClass('loading');

      $.ajax({
        url:         modelData.api.loadMore,
        type:        'POST',
        dataType:    'html',
        data:        JSON.stringify({'filter': JSON.stringify(filter)}),
        contentType: 'application/json; charset=utf-8',
        success:     function (data) {
          $hasMore.replaceWith(data);

          setTimeout(() => {
            const $buttonLoadMore = $component.find('.load-more');

            $buttonLoadMore.on('click', function () {
              loadMore();
            });

            if ($buttonLoadMore)
            {
              onScroll();
            }
          }, 100);
        }
      });
    }

    /**
     * @returns {FilterModel}
     */
    function parseHash() {
      const hash = decodeURIComponent(window.location.hash.replace('#', ''));
      const parts = hash.split('|');

      let part2 = (((parts.length > 0) && parts[1]) ? parts[1] : '');
      if (IS_PRODUCTION && part2)
      {
        part2 = atob(part2);
      }

      const selectedTags = JSON.parse(part2 || '{}');
      for (const category in selectedTags)
      {
        if (selectedTags.hasOwnProperty(category))
        {
          const categoryTags = selectedTags[category];
          for (const group in categoryTags)
          {
            if (categoryTags.hasOwnProperty(group))
            {
              {
                categoryTags[group] = categoryTags[group]
                  .split(',')
                  .map(tag => parseInt(tag, 16));
              }
            }
          }
        }
      }

      return {
        category:     parts[0],
        selectedTags: selectedTags,
      };
    }

    function toHash() {
      const filter = model.filter;
      const hashSelectedTags = {};
      for (const category in filter.selectedTags)
      {
        if (filter.selectedTags.hasOwnProperty(category))
        {
          const hashCategoryTags = hashSelectedTags[category] = {};

          const categoryTags = filter.selectedTags[category];
          for (const group in categoryTags)
          {
            if (categoryTags.hasOwnProperty(group))
            {
              hashCategoryTags[group] = categoryTags[group]
                .map(tag => tag.toString(16))
                .join(',');
            }
          }
        }
      }

      let hashString = JSON.stringify(hashSelectedTags);
      if (IS_PRODUCTION)
      {
        hashString = (hashString === '{}') ? '' : btoa(hashString);
      }

      window.location.hash = `#${filter.category}|${hashString}`;
    }

    function onScroll() {
      const $hasMore = $component.find('.content_browser__has_more');
      const width = $window.width();

      if (width > 767 && $hasMore.length && !$hasMore.hasClass('loading'))
      {
        const scrollBottom = $window.scrollTop() + $window.height();

        const distance = $hasMore.offset().top - scrollBottom;
        if ((distance <= 50)/* && (distance >= 0)*/)
        {
          loadMore();
        }
      }
    }
  });

  const divs = $(".provider_sites__grid .col-md-3");
  for (let i = 0; i < divs.length; i += 2)
  {
    divs.slice(i, i + 2).wrapAll("<div class='provider-col'></div>");
  }
}

/**
 * @returns {string[]}
 */
function extractTags(/** TagModel[] */tags) {
  if (tags)
  {
    return tags.map(tag => tag.name);
  }
}

/**
 * @typedef {{
 *   context: JQuery<HTMLElement>,
 *   data: {
 *     campaigns: number,
 *     news_events: number,
 *     seminar_webinar: number,
 *
 *     amount: number,
 *     hasMore: boolean,
 *     next: number,
 *     api: {
 *        loadMore: string,
 *     },
 *   },
 *   filter: FilterModel,
 *   onFilterUpdate: function()
 * }} ContentBrowserModel
 */

/**
 * @typedef {{
 *   category?: string,
 *   product_area?: TagModel[],
 *   brand?: TagModel[],
 *   event_type?: TagModel[],
 *   seminar_type?: TagModel[],
 *   selectedTags?: Object<string, Object<string, number[]>>,
 * }} FilterModel
 */

/**
 * @typedef {{
 *   id: number,
 *   name: string,
 * }} TagModel
 */
